module.exports = __webpack_public_path__ + "static/media/24_CALCINHA_FIO_DUPLO_ESTAMPADO_04.912bbc65.jpg";